module.exports = __webpack_public_path__ + "static/img/nio_fail_default.8bf8110d.webp";